import React from 'react'
import GalleryContent from './GalleryContent'
import Footer from './components/footer'
function Gallery(){
	return(
	<>
    <section class="intro-single">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-12">
          <div class="title-single-box">
            <h1 class="title-single">Our Works</h1>
            <span class="color-text-a"> </span>
          </div>
        </div>
        
      </div>
    </div>
  </section>
  <section class="news-grid grid">
<div class="container">
<div class="row">
{GalleryContent.map((item, index) => (
        <div class="col-md-4">
          <div class="card-box-b card-shadow news-box">
            <div class="img-box-b">
            <img src={item.image} className={item.class} />
            </div>
           
          </div>
        </div>   
))}
      </div>
</div>
</section>
<Footer/>
    </>
)
	}
	
export default Gallery